/** Strip commas/currency chars and coerce to number. */
export const parseWalletAmount = (v) => {
  if (v == null || v === "") return 0;
  const n = Number(String(v).replace(/[,₹\s]/g, ""));
  return Number.isFinite(n) ? n : 0;
};

export const formatWalletAmount = (v) =>
  parseWalletAmount(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const categoryWalletBalance = (walletData, subKey) => {
  if (!walletData) return 0;
  const sub = walletData[subKey];
  if (sub != null && sub !== "") return parseWalletAmount(sub);
  return parseWalletAmount(walletData.wallet_balance);
};

/** Doctor consultation wallet: forDoctors sub-balance, fallback to total. */
export const getDoctorWalletBalance = (walletData) =>
  categoryWalletBalance(walletData, "forDoctors");

/** Lab / diagnostic wallet: forTests sub-balance, fallback to total. */
export const getLabWalletBalance = (walletData) =>
  categoryWalletBalance(walletData, "forTests");

/** Package wallet: forPackages sub-balance, fallback to total. */
export const getPackageWalletBalance = (walletData) =>
  categoryWalletBalance(walletData, "forPackages");

export const getTotalWalletBalance = (walletData) =>
  parseWalletAmount(walletData?.wallet_balance);

/** Apply booking/cancel response balance fields onto a wallet object. */
export const mergeWalletResponse = (prev, data) => {
  if (!data || typeof data !== "object") return prev || null;
  const next = { ...(prev || {}) };
  const total = data.wallet_balance ?? data.walletBalance;
  if (total != null && total !== "") next.wallet_balance = parseWalletAmount(total);
  if (data.forTestsBalance != null) next.forTests = parseWalletAmount(data.forTestsBalance);
  if (data.forPackagesBalance != null) next.forPackages = parseWalletAmount(data.forPackagesBalance);
  if (data.remainingForDoctorsBalance != null) next.forDoctors = parseWalletAmount(data.remainingForDoctorsBalance);
  if (data.forTests != null) next.forTests = parseWalletAmount(data.forTests);
  if (data.forDoctors != null) next.forDoctors = parseWalletAmount(data.forDoctors);
  if (data.forPackages != null) next.forPackages = parseWalletAmount(data.forPackages);
  return next;
};

/** Amount user can spend at checkout — matches Wallet page / header. */
export const getSpendableWalletBalance = (walletData) =>
  parseWalletAmount(walletData?.wallet_balance);

/** Optional category allocation (informational only). */
export const getCategoryWalletAllocation = (walletData, kind) => {
  if (!walletData) return null;
  const key =
    kind === "consultation" ? "forDoctors" : kind === "package" ? "forPackages" : "forTests";
  const sub = walletData[key];
  if (sub == null || sub === "") return null;
  return parseWalletAmount(sub);
};
